import React, { useEffect } from 'react';

import useApp from 'hooks/useApp';

const useScreenReaderLanguage = () => {
    const { screenReaderLanguage } = useApp();

    useEffect(() => {
        document.documentElement.lang = screenReaderLanguage || "en";
    }, [screenReaderLanguage]);
}

export default useScreenReaderLanguage;